import React, { Component } from "react";
import PropTypes from "prop-types";
import FormUtils from "../lib/FormUtils";
import withLoading from "../containers/withLoading";
import LoadingButton from "./ui/LoadingButton";
import ActionBar from "./ActionBar";
import t from "tcomb-form";
const Form = t.form.Form;

const defaultButton = ({ ui, buttonText, component, onSubmit }) => (
  <LoadingButton
    className="btn-save"
    ui={ui}
    type={component === "form" ? "submit" : "button"}
    onClick={component === "form" ? undefined : onSubmit}
  >
    {buttonText}
  </LoadingButton>
);

@withLoading()
export default class extends Component {
  static propTypes = {
    asyncValidate: PropTypes.func,
    schema: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
    value: PropTypes.object,
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    button: PropTypes.func,
    buttonText: PropTypes.string,
    actionBar: PropTypes.func,
    component: PropTypes.node,
  };

  static defaultProps = {
    buttonText: "Save",
    button: defaultButton,
    component: "form",
  };

  constructor(props) {
    super();
    this.state = {
      value: props.value,
      ...this.getSchema(props.value, props),
    };
  }

  getSchema = (value, props = false) => {
    const { schema } = props || this.props;

    if (typeof schema === "function") {
      return FormUtils.getForm(schema(value), value);
    } else {
      return FormUtils.getForm(schema, value);
    }
  };

  componentWillReceiveProps(props) {
    if (props.schema !== this.props.schema) {
      console.log("SchemaForm -> schemaUpdate");
      this.setState(this.getSchema(this.state.value, props));
    }

    // IDs of form have changed
    const value = this.props.value || {};
    const nextValue = props.value || {};
    if (value.id !== nextValue.id) {
      console.log("SchemaForm -> modelUpdate");
      this.setState({ value: nextValue });
    }
  }

  getValue() {
    return this.form.getValue();
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { asyncValidate, uiAction, uiReset, onSubmit } = this.props;
    if (asyncValidate) {
      try {
        await asyncValidate(this.form.getValue());
      } catch (err) {
        console.log(err);
        return; // validation failed
      }
    }

    const value = this.form.getValue();
    if (!value) return; // validation failed

    if (onSubmit) {
      uiReset();
      uiAction(onSubmit(value));
    }
  };

  onChange = (value, ...rest) => {
    let nextState = { value };

    if (this.props.onChange) {
      const reducer = this.props.onChange(nextState.value, ...rest);
      if (reducer && typeof reducer === "function") {
        nextState = { ...nextState, ...reducer(this.state) };
      }
    }

    this.setState({
      ...nextState,
      ...this.getSchema(nextState.value),
    });
  };

  renderButton = () => {
    const { ui, buttonText } = this.props;
    return (
      <LoadingButton className="btn-save" ui={ui} type="submit">
        {buttonText}
      </LoadingButton>
    );
  };

  render() {
    const { schema, options, value } = this.state;
    const { className, button, actionBar, onCancel, component, formRef } =
      this.props;
    const buttonProps = { ...this.props, onSubmit: this.onSubmit };
    const formProps = { className };
    const Container = component;

    if (component === "form") {
      formProps.onSubmit = this.onSubmit;
      formProps.autoComplete = "off";
    }

    return (
      <Container {...formProps}>
        <Form
          ref={(c) => {
            this.form = c;
            formRef && formRef(c);
          }}
          context={this.props.context}
          type={schema}
          options={options}
          value={value}
          onChange={this.onChange}
        />
        <div className="form-actions">
          {this.props.children}
          {button && !actionBar && button(buttonProps)}
        </div>
        {actionBar && (
          <ActionBar>
            {button && button(buttonProps)}
            <button type="button" className="btn btn-cancel" onClick={onCancel}>
              {value.id ? "Done" : "Cancel"}
            </button>
            {actionBar(this.props)}
          </ActionBar>
        )}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SchemaForm.js